// src/LinkedinIcon.tsx
import { jsx } from "react/jsx-runtime";
var LinkedinIcon = ({ ...props }) => /* @__PURE__ */ jsx(
  "svg",
  {
    width: "21",
    height: "21",
    viewBox: "0 0 21 21",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1.90113 0.0253906C1.04047 0.0253906 0.342773 0.723086 0.342773 1.58374V18.467C0.342773 19.3277 1.04047 20.0254 1.90113 20.0254H18.7844C19.6451 20.0254 20.3428 19.3277 20.3428 18.467V1.58374C20.3428 0.723086 19.6451 0.0253906 18.7844 0.0253906H1.90113ZM8.26491 16.2587H11.0353V11.5837C11.0108 11.2424 11.1265 10.9059 11.3556 10.6519C11.5847 10.3978 11.9075 10.2481 12.2494 10.2373C13.0312 10.2356 13.6949 10.8098 13.8057 11.5837V16.2587H16.5761V11.2374C16.5811 9.5193 15.1948 8.1212 13.4767 8.11168C12.5214 8.13354 11.6258 8.58143 11.0353 9.33272V7.94752H8.26491V16.2587ZM4.1093 7.94752V16.2587H6.87971V7.94752H4.1093ZM4.1093 5.17711C4.1093 5.94215 4.72948 6.56233 5.4945 6.56233C5.86188 6.56233 6.21421 6.41637 6.47398 6.1566C6.73376 5.89683 6.87971 5.54449 6.87971 5.17711C6.87971 4.41209 6.25953 3.79192 5.4945 3.79192C4.72948 3.79192 4.1093 4.41209 4.1093 5.17711Z"
      }
    )
  }
);
var LinkedinIcon_default = LinkedinIcon;

export {
  LinkedinIcon_default
};
